import React from "react"
import styled from "@emotion/styled"

import Isotipo from "../ui/images/isotipo"

const WrapperPrefer = styled.div`
  padding-top: 60px;
  background: #16191a;
  color: #ffffff;
  padding-bottom: 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const TitlePrefer = styled.h2`
  font-size: 27.65px;
  line-height: 116%;
  font-weight: bold;
  max-width: 750px;
  padding: 0 40px;
  margin: 0 auto;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 24px;
  }
`

const ContainerCheck = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 560px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 660px;
    padding: 0 15px;
  }
  @media (min-width: 800px) {
    max-width: 1050px;
  }
`

const Check = styled.div`
  margin: 40px 0;
  display: flex;
  align-items: center;

  @media (max-width: 810px) {
    margin: 25px 0;
  }
`

const Text = styled.span`
  margin-left: 5px;
  width: 240px;
`

const ContainerRankia = styled.div`
  margin-top: 40px;
  text-align: center;
  > p {
    font-size: 12px;
    line-height: 16px;
    font-weight: bold;
  }
  > img {
    width: 231px;
  }
`

const listText: string[] = [
  "+20.000 clientes",
  "+400 instrumentos disponibles",
  "+14 años de experiencia",
  "Mejor atención al cliente Premio Rankia 2020",
  "Primeros en transar Dólar Peso Chileno en el mundo",
  "Primera Fintech del país",
]

const PreferCapitaria = () => {
  return (
    <WrapperPrefer>
      <TitlePrefer>POR QUE LOS TRADERS PREFIEREN CAPITARIA</TitlePrefer>
      <ContainerCheck>
        {listText.map((text: string, idx: number) => (
          <Check key={`idcheck-${idx}`}>
            <Isotipo />
            <Text>{text}</Text>
          </Check>
        ))}
      </ContainerCheck>
      <ContainerRankia>
        <img src="/rankia.png" alt="Rankia" />
      </ContainerRankia>
    </WrapperPrefer>
  )
}

export default PreferCapitaria
